/** @jsx jsx */
import { useState } from "react"
import Img from "gatsby-image"
import Carousel from "nuka-carousel"
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import { Icon } from "frontend/src/components/Icon"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"

function IngredientSlider({ allIcons, product }) {
  const [slideIndex, setSlideIndex] = useState(0)

  // Slide event handler
  const handleSlideToShow = index => {
    setSlideIndex(index)
  }

  // Reduce excess product name
  const getTextContent = data => {
    const content = data[0].children[0].text
    // const extractedText = content.length > 520 ? `${content.substring(0,
    // 520)} ...` : content // Limit content to 520 characters
    const extractedText = content
    return extractedText
  }

  const spreadIcon = (color, iconStyles, num) => (
    <Icon
      key={color + num}
      name={allIcons[0].title}
      size={[15, 20, 15]}
      color={color}
      sx={{ opacity: ["0.3"], ...iconStyles }}
    ></Icon>
  )

  const getIcon = (slideHandler, iconName, slideIndexNumber, color) => {
    const slideFunc = () => slideHandler(slideIndexNumber)
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={slideFunc}
        onKeyUp={slideFunc}
        sx={{ outline: "none" }}
      >
        <Icon
          name={iconName}
          size={[0, 0, 25]}
          color={color}
          sx={{
            display: ["none", "none", "block"],
            cursor: "pointer",
            borderWidth: "0.3px",
          }}
        ></Icon>
      </div>
    )
  }

  const getContentTitle = (ingredient, i) => (
    <div
      key={i}
      sx={{
        display: ["none", "none", "block"],
        borderBottom: "0.1em",
        borderBottomStyle: "solid",
        borderBottomColor: "black",
        outline: "none",
        variant: "text.h5",
        textTransform: "none",
        letterSpacing: "0.336px",
        cursor: "default",
      }}
    >
      {ingredient.ingredientName}
    </div>
  )

  // For larger viewports only
  const controlDiv = (iconToShow, itemDetails, displaySlideIndex) => (
    <div
      sx={{
        width: "250%",
        display: ["none", "none", "flex"],
        justifyContent: "flex-start",
        position: "relative",
        left: "-50%",
      }}
    >
      <div
        sx={{
          ml: "35%",
          width: "30%",
          minWidth: "390px",
          maxWidth: "500px",
          display: ["flex"],
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {displaySlideIndex <= 0
          ? getIcon(handleSlideToShow, iconToShow[2].icon, itemDetails.length - 1, "almostBlack")
          : getIcon(handleSlideToShow, iconToShow[2].icon, displaySlideIndex - 1, "almostBlack")}

        {itemDetails.map((item, i) =>
          displaySlideIndex === i
            ? getContentTitle(item, i)
            : spreadIcon("icon_link", { display: ["none", "none", "block"] }, i)
        )}

        {getIcon(
          handleSlideToShow,
          iconToShow[1].icon,
          (displaySlideIndex + 1) % itemDetails.length,
          "almostBlack"
        )}
      </div>
    </div>
  )

  // For smaller viewports only
  const smallViewControl = (itemDetails, iconGroup, displaySlideIndex) => (
    <div
      sx={{
        width: ["70px", "100px"],
        display: ["flex", "flex", "none"],
        justifyContent: ["space-between", "space-between"],
      }}
    >
      {itemDetails.map((item, i) =>
        displaySlideIndex === i
          ? iconGroup("almostBlack", { display: ["block", "block", "none"] })
          : spreadIcon("icon_link", { display: ["block", "block", "none"] }, i)
      )}
    </div>
  )

  const ingredentNameDiv = item => (
    <div
      sx={{
        width: ["320px", "420px"],
        display: ["flex", "flex", "none"],
        color: "almostBlack",
        variant: "text.h3",
        letterSpacing: ["0.4px", "0.819368px"],
        cursor: "default",
        pl: ["10px", "15px"],
      }}
    >
      {item.ingredientName}
    </div>
  )

  const textDiv = item => (
    <div
      sx={{
        gridRow: "1 /span 1",
        gridColumnStart: [4],
        gridColumnEnd: [5],
        display: "flex",
        justifyContent: "flex-end",
        cursor: "default",
        color: "almostBlack",
        variant: ["text.body1"],
        minWidth: ["320px", "unset", "367px"],
        maxWidth: ["320px", "420px", "550px"],
        height: ["auto", "auto", "100%"],
        px: ["10px", "15px", "none"],
        pt: ["5px", "10px", "none"],
        pb: ["20px", "50px", "none"],
      }}
    >
      {getTextContent(item.ingredientText)}
    </div>
  )

  const imageDiv = item => (
    <div
      sx={{
        gridRow: "1 /span 1",
        gridColumn: "2 / span 1",
        cursor: "default",
        height: ["169px", "370px", "360px"],
        width: ["90%", "90%", "auto"],
      }}
    >
      <Img
        fluid={getFluidFromAsset(item.ingredientImage, 600)}
        sx={{ height: ["169px", "360px", "360px"] }}
      />
    </div>
  )

  const allComponent = ingredientsDetails => (
    <div
      key={"51tt"}
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Carousel
        key={slideIndex}
        slideIndex={slideIndex}
        slidesToShow={1}
        cellSpacing={20}
        enableKeyboardControls={true}
        dragging={true}
        wrapAround={true}
        afterSlide={slideIndex => setSlideIndex(slideIndex)}
        //  Default Previous and Next Button disabled
        renderCenterLeftControls={() => null}
        renderCenterRightControls={() => null}
        renderBottomCenterControls={({ currentSlide }) => (
          <div key={currentSlide}>
            {controlDiv(allIcons, ingredientsDetails, currentSlide)}
            {smallViewControl(ingredientsDetails, spreadIcon, currentSlide)}
          </div>
        )}
      >
        {ingredientsDetails.map((singleElement, i) => (
          <div
            key={i}
            sx={{
              display: ["flex", "flex", "grid"],
              flexDirection: ["column", "column"],
              justifyContent: ["center"],
              alignItems: "center",
              gridTemplateColumns: ["5px 2fr 30px 3fr 5px"],
              gridTemplateRows: ["1fr"],
            }}
          >
            {ingredentNameDiv(singleElement)}
            {textDiv(singleElement)}
            {imageDiv(singleElement)}
          </div>
        ))}
      </Carousel>
    </div>
  )

  return (
    <SectionGrid>
      <SectionGrid.narrow
        sx={{
          height: ["650px", "800px", "400px"],
          display: "flex",
          flexDirection: ["column", "column", "row"],
          justifyContent: ["center"],
          alignItems: "center",
          cursor: "default",
          "*:focus": {
            outline: "none",
          },
        }}
      >
        <div
          key={"51i"}
          sx={{
            width: ["100%", "100%", "100%"],
            height: ["95%", "95%", "90%"],
            cursor: "default",
            maxWidth: "1200px",
          }}
        >
          {allComponent(product.heroIngredients)}
        </div>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { IngredientSlider }
